import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en/translation.json';
import es from '../locales/es/translation.json';
import { OHLA_DOMAIN, OHLA_DOMAIN_V2, TEST_DOMAIN } from './Config';

const storedLang = localStorage.getItem('userLang');
const currentDomain =
  typeof window !== 'undefined' ? window.location.hostname : '';
const isOhlaDomain =
  currentDomain === OHLA_DOMAIN ||
  currentDomain === TEST_DOMAIN ||
  currentDomain === OHLA_DOMAIN_V2;
const savedLang = storedLang ? storedLang : isOhlaDomain ? 'en' : 'es';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  ns: ['translation'],
  defaultNS: 'translation',
  lng: savedLang,
  fallbackLng: 'es',
  keySeparator: '.',
  nsSeparator: ':',
  load: 'languageOnly',
  returnNull: false,
  supportedLngs: ['es', 'en'],
  nonExplicitSupportedLngs: true,
  react: { useSuspense: false },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
